import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React from "react";
import { Formik, Form, Field, FieldArray } from "formik";
import { TextField, CheckboxWithLabel } from "formik-material-ui";
import moment from "moment";
import * as Yup from "yup";
import NumberFormat from "react-number-format";
import { default as MUITextField } from "@material-ui/core/TextField";
import { Button, Grid, SubmitButton, Dialog, SearchSelect, DatePicker, numeral, IconButton, DeleteIcon, AddCircleOutlineOutlinedIcon, makeStyles, FormControlLabel } from "../../../../";
import { Debug } from "../../../../Molecules/Forms/Debug";
import uuidv1 from "uuid/v1";
var subscriptionSchema = Yup.object().shape({
  customer: Yup.string().required("Campo obligatorio"),
  billing_cycle_anchor: Yup.date().required()
});
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      "flex-wrap": "wrap"
    },
    check: {
      "padding-right": "30px",
      margin: "0px"
    },
    select: {
      width: "45%"
    },
    mr30: {
      "margin-right": "30px"
    },
    flex: {
      display: "flex",
      "align-items": "baseline"
    },
    client: {
      "min-width": "50%"
    },
    minw30: {
      "min-width": "30%"
    },
    actions: {
      display: "flex",
      padding: "30px",
      "justify-content": "flex-end"
    }
  };
});

var DialogSubscription = function DialogSubscription(props) {
  // console.log('DialogSubscription props', props)
  var subscription = props.subscription,
      clients = props.clients,
      plans = props.plans,
      products = props.products,
      variant = props.variant,
      translation = props.translation,
      open = props.open,
      onClose = props.onClose,
      createSubscription = props.createSubscription,
      editSubscription = props.editSubscription;
  var initialValues = variant === "add" ? {
    customer: "",
    billing_cycle_anchor: null,
    items: [{
      product: "",
      plan: "",
      interval_count: "",
      amount: ""
    }]
  } : subscription;
  var classes = useStyles();
  var title = "";

  if (variant === "edit") {
    title = translation ? translation.titles.edit_subscription : "Edit subscription";
  } else if (variant === "add") {
    title = translation ? translation.titles.add_subscription : "Add subscription";
  }

  var setPlanData = function setPlanData(values) {
    values.items && values.items.forEach(function (item, index) {
      var plan = plans && plans.find(function (plan) {
        return plan.value === values.items[index].plan;
      });
      item.interval_count = plan && plan.interval_count;
      item.amount = plan && plan.amount;
    });
  };

  return [/*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    maxWidth: "md",
    title: title,
    open: open,
    onClose: onClose,
    mode: variant,
    key: 0
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialValues,
    validationSchema: subscriptionSchema,
    onSubmit: function onSubmit(values, _ref) {
      var resetForm = _ref.resetForm;

      if (variant === "add") {
        createSubscription(_objectSpread(_objectSpread({}, values), {}, {
          key: uuidv1(),
          billing_cycle_anchor: moment(values.billing_cycle_anchor).format("X")
        }));
        resetForm = {
          name: "",
          type: "",
          account_number: "",
          message: ""
        };
        onClose();
      } else if (variant === "edit") {
        editSubscription(values);
        onClose();
      }
    },
    render: function render(_ref2) {
      var values = _ref2.values,
          isValid = _ref2.isValid,
          isSubmitting = _ref2.isSubmitting;
      values && setPlanData(values);
      return /*#__PURE__*/React.createElement(Form, {
        "data-cy": "add-subscription",
        className: classes.form
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.root
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        md: 12,
        className: classes.flex
      }, /*#__PURE__*/React.createElement(Field, {
        "data-cy": "customer",
        name: "customer",
        key: "customer",
        component: SearchSelect,
        placeholder: translation ? translation.selects.client.placeholder : "Franchise",
        className: [classes.mr30, classes.client].join(" "),
        options: clients,
        clickable: variant !== "view"
      }), /*#__PURE__*/React.createElement(Field, {
        "data-cy": "billing_cycle_anchor",
        name: "billing_cycle_anchor",
        key: "billing_cycle_anchor",
        className: classes.mr15,
        label: translation ? translation.inputs.first_invoice_date : "First invoice date",
        component: DatePicker,
        value: values.billing_cycle_anchor,
        disabled: variant === "view"
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        md: 12,
        className: classes.root
      }, /*#__PURE__*/React.createElement(FormControlLabel, {
        className: classes.check,
        control: /*#__PURE__*/React.createElement(Field, {
          label: translation ? translation.inputs.stripe : "Manual subscription",
          name: "manual",
          component: CheckboxWithLabel,
          color: "primary",
          disabled: variant === "view" || values.stripe
        }),
        label: translation ? translation.inputs.stripe : "Manual subscription"
      }), /*#__PURE__*/React.createElement(FormControlLabel, {
        className: classes.check,
        control: /*#__PURE__*/React.createElement(Field, {
          label: translation ? translation.inputs.stripe : "Stripe",
          name: "stripe",
          component: CheckboxWithLabel,
          color: "primary",
          disabled: variant === "view" || values.manual
        }),
        label: translation ? translation.inputs.stripe : "Create in Stripe"
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        md: 12,
        className: classes.root,
        style: {
          height: "400px"
        }
      }, values.manual && [/*#__PURE__*/React.createElement(Field, {
        name: "fixed",
        "data-cy": "fixed",
        key: "fixed",
        component: TextField,
        type: "number",
        variant: "outlined",
        className: [classes.mr30, classes.minw30].join(" "),
        label: translation ? translation.inputs.fixed : "Fixed amount (minimum)",
        disabled: variant === "view"
      }), /*#__PURE__*/React.createElement(Field, {
        name: "variable",
        "data-cy": "variable",
        key: "variable",
        component: TextField,
        type: "number",
        variant: "outlined",
        label: translation ? translation.inputs.variable : "Variable amount (percentage)",
        className: [classes.mr30, classes.minw30].join(" "),
        disabled: variant === "view"
      }), /*#__PURE__*/React.createElement(Field, {
        name: "interval_count",
        "data-cy": "interval_count",
        key: "interval_count",
        type: "number",
        component: TextField,
        variant: "outlined",
        label: translation ? translation.inputs.frequency : "Invoice frequency in months",
        className: [classes.mr30, classes.minw30].join(" "),
        disabled: variant === "view"
      })], values.stripe && /*#__PURE__*/React.createElement(FieldArray, {
        name: "items",
        render: function render(_ref3) {
          var insert = _ref3.insert,
              remove = _ref3.remove,
              push = _ref3.push;
          return values.items.length > 0 ? values.items.map(function (field, index) {
            return /*#__PURE__*/React.createElement(Grid, {
              item: true,
              md: 12,
              className: classes.flex,
              key: index
            }, /*#__PURE__*/React.createElement(Field, {
              name: "items[".concat(index, "].product"),
              key: "product",
              className: [classes.mr30, classes.select].join(" "),
              component: SearchSelect,
              placeholder: translation ? translation.selects.products.placeholder : "Product",
              options: products,
              variant: "outlined",
              disabled: variant === "view"
            }), /*#__PURE__*/React.createElement(Field, {
              name: "items[".concat(index, "].plan"),
              key: "plan",
              className: [classes.mr30, classes.select].join(" "),
              component: SearchSelect,
              placeholder: translation ? translation.selects.plans.placeholder : "Plan",
              value: values.items[index].plan,
              options: plans && plans.filter(function (plan) {
                return plan.product === values.items[index].product;
              }),
              variant: "outlined",
              disabled: variant === "view"
            }), /*#__PURE__*/React.createElement(Field, {
              name: "items[".concat(index, "].interval_count"),
              "data-cy": "items[".concat(index, "].interval_count"),
              key: "items[".concat(index, "].interval_count"),
              component: TextField,
              variant: "outlined",
              value: values.items[index].interval_count,
              className: [classes.mr30, classes.w10].join(" "),
              disabled: true
            }), /*#__PURE__*/React.createElement(Field, {
              name: "items[".concat(index, "].amount")
            }, function (_ref4) {
              var field = _ref4.field,
                  form = _ref4.form;
              return /*#__PURE__*/React.createElement(NumberFormat, {
                className: [classes.mr30, classes.w10].join(" "),
                name: field.name,
                value: field.value,
                disabled: true,
                placeholder: translation ? translation.inputs.amount : "Total",
                label: translation ? translation.inputs.amount : "Total",
                inputmode: "numeric",
                thousandSeparator: ".",
                decimalSeparator: ",",
                variant: "outlined",
                customInput: MUITextField,
                onValueChange: function onValueChange(val) {
                  return form.setFieldValue(field.name, val.floatValue);
                }
              });
            }), variant !== "view" && /*#__PURE__*/React.createElement(IconButton, {
              edge: "end",
              "data-cy": "delete",
              color: "secondary",
              onClick: function onClick() {
                return remove(index);
              }
            }, /*#__PURE__*/React.createElement(DeleteIcon, null)), variant !== "view" && index === values.items.length - 1 && /*#__PURE__*/React.createElement(IconButton, {
              onClick: function onClick() {
                return push({
                  plan: ""
                });
              },
              edge: "end",
              "data-cy": "add",
              color: "primary"
            }, /*#__PURE__*/React.createElement(AddCircleOutlineOutlinedIcon, null)));
          }) : /*#__PURE__*/React.createElement(Button, {
            onClick: function onClick() {
              return push({
                plan: ""
              });
            },
            edge: "end",
            "data-cy": "add",
            color: "primary",
            variant: "outlined"
          }, translation ? translation.buttons.add_item : "Add items");
        }
      })), variant !== "view" && /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.actions
      }, /*#__PURE__*/React.createElement(Button, {
        "data-cy": "cancel",
        type: "button",
        size: "medium",
        className: classes.mr30,
        color: "secondary",
        variant: "outlined",
        onClick: onClose
      }, translation ? translation.buttons.cancel : "Cancel"), /*#__PURE__*/React.createElement(Button, {
        "data-cy": "submit",
        size: "medium",
        color: "primary",
        variant: "outlined",
        disabled: !isValid || isSubmitting,
        component: SubmitButton,
        type: "submit"
      }, variant === "add" ? translation ? translation.buttons.add : "Add" : translation ? translation.buttons.save : "Save"))));
    }
  })))];
};

export { DialogSubscription };